import { Inject, Injectable } from '@angular/core';
import { BUSINESS_INFO_SERVICE_TOKEN } from '../../tokens';
import { ObservableWorkStateMap, WorkStateMap } from '@vendasta/rx-utils/work-state';
import { BehaviorSubject, merge, Observable } from 'rxjs';
import { filter, first } from 'rxjs/operators';
import { AccountTag, SocialURLs } from '../../interface';

@Injectable()
export class OpportunityBusinessService {
  private readonly workStateMap = new ObservableWorkStateMap<string, BusinessInfo>();
  public readonly state: WorkStateMap<string, BusinessInfo> = this.workStateMap;

  private readonly currentBusiness$$ = new BehaviorSubject<BusinessInfo>(null);
  public readonly currentBusiness$ = this.currentBusiness$$.pipe(filter<BusinessInfo>(Boolean));

  constructor(
    @Inject(BUSINESS_INFO_SERVICE_TOKEN)
    private readonly businessInfoService: BusinessInfoService,
  ) {}

  loadBusinessAndSetSelected(accountId: string): Observable<BusinessInfo> {
    const business$ = this.businessInfoService.getBusinessData(accountId);
    const result$ = merge(business$, this.state.getWorkResults$(accountId)).pipe(first());
    result$.subscribe((value) => this.currentBusiness$$.next(value));
    return result$;
  }

  getMarketName(partnerId: string, marketId: string): Observable<string> {
    return this.businessInfoService.getMarketName(partnerId, marketId);
  }

  getBusinessDataUrl(accountId: string, isEdit: boolean): string {
    return this.businessInfoService.getBusinessDataUrl(accountId, isEdit);
  }

  getAccountTags(accountId?: string): Observable<AccountTag[]> {
    return this.businessInfoService.getAccountTags(accountId);
  }

  canEditCustomerIdentifier(): Observable<boolean> {
    return this.businessInfoService.canEditCustomerIdentifier();
  }

  canEditCustomFields(): Observable<boolean> {
    return this.businessInfoService.canEditCustomFields();
  }
}
export interface BusinessInfo {
  name: string;
  partnerId: string;
  marketId: string;
  streetAddress: string;
  city: string;
  state: string;
  countryCode: string;
  zip: string;
  phoneNumber: string;
  website: string;
  businessId: string;
  serviceCategories: string[];
  socialUrls: SocialURLs;
  vCategories: string[];
}

export interface BusinessInfoService {
  getBusinessData(businessId: string): Observable<BusinessInfo>;

  getBusinessDataUrl(businessId: string, isEdit: boolean): string;

  getAccountTags(businessId?: string): Observable<AccountTag[]>;

  getMarketName(partnerId?: string, marketId?: string): Observable<string>;

  canEditCustomerIdentifier(): Observable<boolean>; // "salesperson_can_edit_customer_id" FF
  canEditCustomFields(): Observable<boolean>; // "custom_fields" enabled_feature
}

export interface BusinessDataUrls {
  info: string;
  edit: string;
}
